import Svg from 'components/utilities/svg'

const EndmillIcon = ({ ...props }) => (
  <Svg viewBox="0 0 12 12" {...props}>
    <title>Endmill Icon</title>
    <path d="M8.1 10.9a.5.5 0 0 1-.5.5H4.777a6.759 6.759 0 0 0 2.321-1.629c.413-.447.74-.95 1.002-1.464V10.9ZM8 4a.1.1 0 0 1 .1.1v1.735c-.051.26-.116.54-.202.825-.266.888-.704 1.827-1.388 2.569a6.008 6.008 0 0 1-2.61 1.644V7.348A6.752 6.752 0 0 0 6.098 5.77 6.676 6.676 0 0 0 7.25 4H8ZM6.36 4a5.655 5.655 0 0 1-.85 1.229A5.93 5.93 0 0 1 3.9 6.458V4.1A.1.1 0 0 1 4 4h2.36ZM10.243 2.332A1.6 1.6 0 0 1 8.734 3.4H3.268a1.6 1.6 0 0 1-1.51-1.068L1.2.75h1.273l.418 1.183c.056.16.208.267.378.267h5.466a.4.4 0 0 0 .377-.267L9.53.75h1.273l-.559 1.582Z" />
  </Svg>
)

EndmillIcon.displayName = 'Endmill'

export default EndmillIcon
